import { sendToMixpanel, getUserProps } from '../mixpanel';
import type { SearchResultsBaseProperties } from './search-results-base-properties';

export interface SelectSortOrderProps {
  sortOrderSelected: string;
  baseProperties?: SearchResultsBaseProperties;
}

export default ({
  sortOrderSelected,
  baseProperties = {},
}: SelectSortOrderProps): void =>
  sendToMixpanel('Select Sort Order', {
    ...baseProperties,
    ...getUserProps(),
    sortOrderSelected,
  });
